import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Image from 'components/image';
import ParallaxBgImage from 'components/parallax-bg-image';
import ParallaxTextPanel from 'components/parallax-text-panel';
import imageResizer from 'js/image-resizer';
import { Parallax } from 'react-parallax';
import useBreakpoints from 'hooks/use-breakpoints';

const QuoteWithBackgroundBlock = ({
  text,
  author,
  authorTitle,
  quoteBackgroundColor,
  textColor,
  backgroundImage,
}) => {
  const { isMobile } = useBreakpoints(true);
  const [imageHeight, setImageHeight] = useState(0);
  const [imageWidth, setImageWidth] = useState(0);

  useEffect(() => {
    if (typeof isMobile === 'undefined') {
      return;
    }

    if (isMobile) {
      setImageHeight(
        imageResizer.calcImageHeight(
          imageResizer.getHeightWithParallaxOffset(630, 40),
          100
        )
      );
    } else {
      setImageHeight(
        imageResizer.calcImageHeight(
          imageResizer.getHeightByWidthAndProportion(
            window.screen.width,
            1440,
            imageResizer.getHeightWithParallaxOffset(826, 40)
          ),
          100
        )
      );
    }
  }, [isMobile]);

  useEffect(() => {
    setImageWidth(imageResizer.calcImageWidth(window.screen.width, 100));
  }, []);

  return (
    <div className="quote-with-background-block">
      {backgroundImage && imageHeight && imageWidth ? (
        <div className="quote-with-background-block__image-container">
          <ParallaxBgImage
            imageClassName="image_size_quote-with-background-block"
            backgroundImage={backgroundImage}
            imageWidth={imageWidth}
            imageHeight={imageHeight}
          />
        </div>
      ) : null}
      <div className="quote-with-background-block__inner">
        <div className="quote-with-background-block__container">
          <Parallax
            className="quote-with-background-block__text-animation-container"
            renderLayer={percentage => (
              <figure className="quote-with-background-block__quote">
                {text && (
                  <ParallaxTextPanel
                    text={text}
                    percentage={percentage}
                    textBackgroundColor={quoteBackgroundColor}
                    textColor={textColor}
                    textAnimationPercentage={0.2}
                  >
                    <blockquote className="quote-with-background-block__text">
                      {text}
                    </blockquote>
                    {(author || authorTitle) && (
                      <figcaption className="quote-with-background-block__caption">
                        {author && (
                          <div className="quote-with-background-block__author">
                            {author}
                          </div>
                        )}
                        {authorTitle && (
                          <div className="quote-with-background-block__title">
                            {authorTitle}
                          </div>
                        )}
                      </figcaption>
                    )}
                  </ParallaxTextPanel>
                )}
              </figure>
            )}
          />
        </div>
      </div>
    </div>
  );
};
QuoteWithBackgroundBlock.propTypes = {
  text: PropTypes.string,
  author: PropTypes.string,
  authorTitle: PropTypes.string,
  quoteBackgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  backgroundImage: PropTypes.exact(Image.propTypes),
};

export default QuoteWithBackgroundBlock;
